//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../AME/AME.AMEBaseBuilder.js";
let d=[[],[[[],"AddQualifier",{},0,0],[["qualifier","qualifierType"],"ChangeQualifierType",{},2,0],[["qualifier"],"InsertOperand",{},1,0],[["actionOperand"],"ResetActionValue",{},1,0],[["conditionItem"],"RemoveActionItem",{},1,0],[["operandItem"],"AddOperandValue",{},1,0],[["actionItem","moveDirection"],"MoveActionItem",{},2,0],[["operandItem","textValue"],"SetOperandValueWithConstantText",{},2,0],[["operand"],"InsertOperator",{},1,0],[["operatorItem","operatorType"],"ChangeOperatorType",{},2,0]],[]];
SPLM.AME.PlcStateChartActionBuilder = class extends SPLM.AME.AMEBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.PlcStateChartActionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.PlcStateChartActionBuilder.MoveAction = Object.freeze({
    "Up" : "Up", "Down" : "Down"});

SPLM.AME.PlcStateChartActionBuilder.ActionType = Object.freeze({
    "Entry" : "Entry", "Doactivity" : "Doactivity", "Exit" : "Exit"});

SPLM.AME.PlcStateChartActionBuilder.QualifierType = Object.freeze({
    "N" : "N", "S" : "S", "R" : "R"});

SPLM.AME.PlcStateChartActionBuilder.OperatorType = Object.freeze({
    "Assign" : "Assign", "Add" : "Add", "Sub" : "Sub", "Multiply" : "Multiply", "Divide" : "Divide", "Equal" : "Equal", "Between" : "Between", "Lessthan" : "Lessthan", "Greaterthan" : "Greaterthan", "Lessthanequal" : "Lessthanequal", "Greaterthanequal" : "Greaterthanequal", "And" : "And", "Or" : "Or"});

export default SPLM;